import { render, staticRenderFns } from "./menu-and-image-slider.vue?vue&type=template&id=a7f8300a&scoped=true"
import script from "./menu-and-image-slider.vue?vue&type=script&lang=js"
export * from "./menu-and-image-slider.vue?vue&type=script&lang=js"
import style0 from "./menu-and-image-slider.vue?vue&type=style&index=0&id=a7f8300a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@2.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f8300a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/amytran/ShopifyProjects/titan22-astro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7f8300a')) {
      api.createRecord('a7f8300a', component.options)
    } else {
      api.reload('a7f8300a', component.options)
    }
    module.hot.accept("./menu-and-image-slider.vue?vue&type=template&id=a7f8300a&scoped=true", function () {
      api.rerender('a7f8300a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/menu-and-image-slider.vue"
export default component.exports